import { useState } from 'react'
import { useRequestPasswordReset } from '../hooks/useRequestPasswordReset'
import Loader from './Loader'

const RequestPasswordReset = () => {
    const [email, setEmail] = useState('')
    const {requestPasswordReset, error, isLoading} = useRequestPasswordReset()

    const handleSubmit = async (e) => {
        e.preventDefault()
        await requestPasswordReset(email)
    }

    if (isLoading) {
        return <Loader />
    }

    return (
        <div className="request-password-container">
            <form className="requestPasswordReset" onSubmit={handleSubmit}>
                <h3>Reset Password</h3>
                <div className="email-input-section">
                    <label>Email address:</label>
                    <input type="email" onChange={(e) => setEmail(e.target.value)} value={email} />
                </div>
                <button disabled={isLoading}>Submit</button>
                <div className="code-sent-section">
                    <p>Reset code received? <a href="/reset-password">Click Here</a></p>
                </div>
                {error && <div className="error">{error}</div>}
            </form>
        </div>
    )
}

export default RequestPasswordReset